import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/ProcessNode/completed.png'
import _imports_1 from '../../assets/imgs/ProcessNode/wait.png'
import _imports_2 from '../../assets/imgs/ProcessNode/process.png'
import _imports_3 from '../../assets/imgs/ProcessNode/supplement.png'


const _hoisted_1 = { class: "process-wrapper" }
const _hoisted_2 = { class: "process-steps-wrapper" }
const _hoisted_3 = { class: "process-Title-tip" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "process-tip-content" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"width":"100%","display":"inline-block"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "温馨提示：为提高分子公司开业筹备效率，大部分流程可并行，可自行根据进度提交资料审批，"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#1867ad"} }, "无须严格按照流程进行!")
  ])
], -1)
const _hoisted_6 = { class: "process-card" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "node-name" }
const _hoisted_10 = {
  key: 0,
  class: "img-icon",
  src: _imports_0
}
const _hoisted_11 = {
  key: 1,
  class: "img-icon",
  src: _imports_1
}
const _hoisted_12 = {
  key: 2,
  class: "img-icon",
  src: _imports_2
}
const _hoisted_13 = {
  key: 3,
  class: "img-icon",
  src: _imports_3
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)

import { onMounted, watch, ref, computed, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import Title from "@/components/Title.vue";
import { message } from "ant-design-vue";
import { getWorkflowData } from "@/api/process";
import createStore from "@/store/index";
import { useStore } from "vuex";
import { number, string } from "vue-types";
import { NodeItem } from "../../types/procss";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const active = ref<number>(-1);
const isApproveFlag = ref<boolean>(true);

const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);

const flow_data = ref<NodeItem[] | undefined>(undefined);
const Spinning = ref(true);
const process_list = ref<any[]>([]);
const routeQuery = ref({});

const handleNodeClick = (e: any, flag = false) => {
  //flag是是否调用 handleWorkflowData方法的标识，防止重复调用
  active.value = e.id;
  if (route.query.type) {
    routeQuery.value = { ...route.query, type: e.Code, id: e.id };
  } else {
    routeQuery.value = {};
  }
  // console.log("handleNodeClick");

  router.push({
    path: e.href,
    query: routeQuery.value,
  });
  handleWorkflowData();
};

const getActive = (e: any, flag = false) => {
  //flag是是否调用 handleWorkflowData方法的标识，防止重复调用
  active.value = e.id;
  handleClick(e, flag);
};

watch(route, (val) => {
  if (val.path == "/process") {
    handleWorkflowData();
  }
});
const firstInValue = ref<boolean>(true); //从流程节点第一次进带子节点type
const handleClick = (e: any, flag = false) => {
  if (route.query.type) {
    routeQuery.value = {
      ...route.query,
      type: firstInValue.value ? route.query.type : e.Code,
      id: firstInValue.value ? route.query.id : e.id,
    };
  } else {
    routeQuery.value = {};
  }
  firstInValue.value = false;
  if (route.query.type) {
    // console.log("handleClick从列表来");
    router.push({
      path: e.href,
      query: routeQuery.value,
    });
  } else {
    // console.log("handleClick从节点来");

    router.push({
      path: e.href,
    });
  }
  if (flag) {
    return;
  }
  if (!route.query.id || !route.query.type) {
    handleWorkflowData();
  }
};

// 获取流程节点
const handleWorkflowData = async () => {
  flow_data.value = null;
  Spinning.value = true;
  const staffId = route.query.staffId || 0;
  const { Data, Success, Message } = await getWorkflowData(staffId);
  if (Success) {
    let processList = [
      {
        url: require("../../assets/imgs/ProcessNode/money.png"),
        Title: "财务预算及借款",
        href: "/process/financial",
        Code: "2",
        includes: ["201", "202"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/address.png"),
        Title: "选址及房屋租赁",
        href: "/process/location",
        Code: "3",
        includes: ["301", "302", "303"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/system.png"),
        Title: "开设系统账号",
        href: "/process/registered",
        Code: "4",
        includes: ["401", "402"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/register.png"),
        Title: "工商注册及备案",
        href: "/process/business",
        Code: "5",
        includes: ["501", "502", "503", "504"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/bank-person.png"),
        Title: "银行开户及税务报道",
        href: "/process/bank",
        Code: "6",
        includes: ["601", "602", "603"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/accounticon.png"),
        Title: "账套编号申请",
        href: "/process/accountApply",
        Code: "13",
        includes: ["13"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/staff-move.png"),
        Title: "员工调动、客户及人员转移",
        href: "/process/employee",
        Code: "7",
        includes: ["701", "702"], //当Data数据返回为空时 锚定这个点
      },
      {
        url: require("../../assets/imgs/ProcessNode/open-business.png"),
        Title: "正式开业及注资",
        href: "/process/opening",
        Code: "8",
        includes: ["8"], //当Data数据返回为空时 锚定这个点
      },
    ];
    // 1-待办，2-进行中，3-已完成可补充，4-补充进行中，5-已完成
    let statusMap = {
      1: "待办",
      2: "进行中",
      3: "已完成可补充",
      4: "进行中",
      5: "已完成",
    };
    if (Data.length != 0) {
      process_list.value = [];
      Data.forEach((item) => {
        processList.forEach((process) => {
          if (item.Code == process.Code) {
            process_list.value.push({
              ...process,
              id: item.Id,
              State: statusMap[item.State],
              IsAnchorPoint: item.IsAnchorPoint,
              ChildAnchorPointCode: item.ChildAnchorPointCode,
            });
          }
        });
      });

      const code = route.query.type;
      if (code && route.query.id) {
        // console.log("work带id");

        //从流程列表中进入
        let _currentNode = Data.find((item) => item.Code == code);

        let _parentNode;
        if (code == "8" || code == "13") {
          _parentNode = process_list.value.find((item) => item.Code == code);
        } else {
          if (_currentNode.ParentCode !== "0") {
            _parentNode = process_list.value.find((item) => {
              return item.Code == _currentNode.ParentCode;
            });
          } else {
            _parentNode = process_list.value.find((item) => {
              return item.Code == _currentNode.Code;
            });
          }
        }

        getActive(_parentNode, true);
      } else {
        // console.log("work不带id");
        //从流程节点中进入
        if (route.path == "/process") {
          let _current = process_list.value.find(
            (item) => item.IsAnchorPoint == true
          );
          getActive(_current ? _current : process_list.value[0], true);
        } else {
          let _current = process_list.value.find(
            (item) => item.href == route.path
          );
          getActive(_current, true);
        }
      }
    } else {
      if (route.path == "/process") {
        const code = route.query.type;
        if (code) {
          //找到当前code的流程节点数据
          const _current = processList.find((item) => {
            return item.includes.includes(code);
          });
          getActive(_current, true);
        }
      } else {
        const _current = processList.find((item) => item.href == route.path);
        getActive(_current, true);
      }
    }
    setTimeout(() => {
      flow_data.value = Data;
    }, 100);
  } else {
    message.warning(Message);
  }
};

onMounted(async () => {
  handleWorkflowData();
});
const isLoading = ref<boolean>(false);
const reapplyOk = (query: boolean) => {
  isLoading.value = query;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: isLoading.value,
    size: "large"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Title, { title: "流程节点" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "tip-icon",
              src: require('../../assets/imgs/ProcessNode/tip.png')
            }, null, 8, _hoisted_4),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process_list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['process-node-box', { active: active.value == item.id }]),
                key: index,
                onClick: ($event: any) => (handleNodeClick(item))
              }, [
                _createElementVNode("img", {
                  class: "node-icon",
                  src: item.url
                }, null, 8, _hoisted_8),
                _createElementVNode("a", _hoisted_9, _toDisplayString(item.Title), 1),
                (
                item.State === '已完成' &&
                (_unref(personInfo).IsCreate == 1 ||
                  (_unref(route).query.id && _unref(personInfo).IsCreate == 0))
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true),
                (
                item.State === '待办' &&
                (_unref(personInfo).IsCreate == 1 ||
                  (_unref(route).query.id && _unref(personInfo).IsCreate == 0))
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : _createCommentVNode("", true),
                (
                item.State === '进行中' &&
                (_unref(personInfo).IsCreate == 1 ||
                  (_unref(route).query.id && _unref(personInfo).IsCreate == 0))
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                  : _createCommentVNode("", true),
                (
                item.State &&
                item.State.includes('可补充') &&
                (_unref(personInfo).IsCreate == 1 ||
                  (_unref(route).query.id && _unref(personInfo).IsCreate == 0))
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : _createCommentVNode("", true),
                _hoisted_14
              ], 10, _hoisted_7))
            }), 128))
          ])
        ]),
        _createVNode(_component_router_view, {
          "flow-data": flow_data.value,
          onUpdateFlow: handleWorkflowData,
          onReapplyOk: reapplyOk
        }, null, 8, ["flow-data"])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})